import React from 'react';
import PropTypes from 'prop-types';
import { LabeledRadio } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import styled from 'styled-components';
import { connect } from '../../Store';

const Wrapper = styled.div`
  padding-top: ${rem(7)};
  padding-bottom: ${rem(20)};
`;

const RowWrapper = styled.div`
  height: ${rem(25)};
`;

class RadioGroup extends React.Component {
  render() {
    const { radios, selectedId, onChange } = this.props;
    return (
      <Wrapper>
        {radios.map(radio => {
          return (
            <RowWrapper>
              <LabeledRadio
                labelText={radio.label}
                checked={radio.id === selectedId}
                onClick={() => onChange(radio.id)}
              />
            </RowWrapper>
          );
        })}
      </Wrapper>
    );
  }
}

RadioGroup.propTypes = {
  radios: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.number,
    }),
  ),
  selectedId: PropTypes.number,
  onChange: PropTypes.func,
};

RadioGroup.defaultProps = {
  radios: [],
  selectedId: 1,
  onChange: () => {},
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(RadioGroup);



// WEBPACK FOOTER //
// ./src/Components/RadioGroup/index.jsx